import axios from 'axios'
import {APIUrls, Headers} from 'src/app/helpers/connection/API'
import { APIResponseModel } from "src/app/helpers/connection/models"
import {OptionsModel} from 'src/app/helpers/components/forms/Inputs'
import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query'
import {toast} from 'sonner'

import {
  AdminUserPostRequest,
  CodeType,
  CreatelibraryAccessPermission,
  CreateProcessAccessPermission
} from './_models'


export async function getAdminUser(code:CodeType) {
  const {data: resp} = await axios.get(`${APIUrls.Services.User}/${code}`);
   toast.success('User deleted successfully');
  if (resp.data){
    return resp.data
  }
  return resp
}

export async function setUserPermission(data:any) {
  const {data: resp} = await axios.post(`${APIUrls.Services.User}/${data?.id}/permission-groups`,data);
  if (resp.data){
    return resp.data
  }
  return resp
}


export async function updateUserPermission(data:any) {
  try {
    const {data: resp} = await axios.put(`${APIUrls.Services.User}/${data?.id}/permission-groups`, data);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function deleteUserPermission(data:any) {
  console.log(data);
  
  try {
    const {data: resp} = await axios.delete(`${APIUrls.Services.User}/${data?.userCode}/permission-groups`,data);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getAdminUserList() {
  const {data: resp} = await axios.get(`${APIUrls.Services.User}`);
  if (resp.data){
    return resp.data
  }
  return resp
}


export async function postAdminUser(newUser:AdminUserPostRequest) {
  const {data: resp} = await axios.post(`${APIUrls.Services.User}`, newUser);
  if (resp.data){
    return resp.data
  }
  return resp
}

export async function putAdminUser(code:CodeType, updatedUser:AdminUserPostRequest) {
  try {
    const {data: resp} = await axios.put(`${APIUrls.Services.User}/${code}`, updatedUser);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function deleteAdminUser(code:CodeType) {
  try {
    const {data: resp} = await axios.delete(`${APIUrls.Services.User}/${code}`);
    return resp
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getAdminDepartmentList() {
  const {data: resp} = await axios.get(`${APIUrls.Services.Department}`);
  if (resp.data){
    return resp.data
  }

  return resp
}

export async function getAdminPositionList() {
  const {data: resp} = await axios.get(`${APIUrls.Services.Position}`);
  if (resp.data){
    return resp.data
  }
  return resp
}



export async function getAdminPermissionList() {
  const {data: resp} = await axios.get(`${APIUrls.Services.Access}`);
  if (resp.data){
    return resp.data
  }
  return resp
}


export async function getProfileDesign(status?: string) {
  const {data: resp} = await axios.get(`${APIUrls.Record.RecProfiles}`, {
    params: {
      status: status
    }
  });
  if (resp.data){
    return resp.data;
  }
  return resp;
}

export async function getTaggingLibraries(status?: string) {
  const {data: resp} = await axios.get(`${APIUrls.Record.TaggingLib}`, {
    params: {
      status: status
    }
  });
  if (resp.data){
    return resp.data;
  }
  return resp;
}
//Library access permission APIs

export async function getLibraryAccessPermissionListing(pageNumber: number) {
  const {data: resp} = await axios.get(`${APIUrls.Library.LibraryAccessPermissionListing}/${pageNumber}`);
  if (resp.data){
    return resp.data;
  }
  return resp;
}

export async function createLibraryAccessPermission(data: any) {
  try {
    const {data: resp} = await axios.post(`${APIUrls.Library?.LibraryAccessPermission}`, data)
    toast.success('Library access permission created successfully')
    if (resp.data) {
      return resp.data
    }
    return resp
  } catch (error: any) {
    toast.error('Failed to create library access permission')
    console.error('Error creating library access permission:', error)
    throw error
  }
}

export async function getLibraryAccessPermissionByCode(code: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.Library.LibraryAccessPermission}/GET/${code}`
    )
    toast.success('Library access permission fetched successfully')
    return resp
  } catch (error: any) {
    toast.error('Failed to fetch library access permission')
    console.error('Error fetching library access permission:', error)
    throw error
  }
}

export async function updateLibraryAccessPermission( data: any) {
  try {
    const { data: resp } = await axios.put(
      `${APIUrls.Library.LibraryAccessPermission}`,
      data
    )
    toast.success('Library access permission updated successfully')
    if (resp.data) {
      return resp.data
    }
    return resp
  } catch (error: any) {
    toast.error('Failed to update library access permission')
    console.error('Error updating library access permission:', error)
    throw error
  }
}

export async function deleteLibraryAccessPermission(code: string) {
  try {
    const { data: resp } = await axios.delete(
      `${APIUrls.Library.LibraryAccessPermission}/${code}`
    )
    toast.success('Library access permission deleted successfully')
    return resp
  } catch (error: any) {
    toast.error('Failed to delete library access permission')
    console.error('Error deleting library access permission:', error)
    throw error
  }
}



//process access permission APIs
export async function getProcessAccessPermission() {
  const {data: resp} = await axios.get(`${APIUrls.Process.ProcessAccessPermission}`);
  if (resp.data){
    return resp.data;
  }
  return resp;
}

export async function createProcessPermission(data:CreateProcessAccessPermission) {
  const {data: resp} = await axios.post(`${APIUrls.Process?.CreateProcessPermission}`, data);
  if (resp.data){
    return resp.data
  }
  return resp
}

export async function getProcessPermissionByCode(processDesignCode: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.Process.ProcessAccessPermission}/${processDesignCode}`
    );

    toast.success('Process permission fetched successfully');
    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch process permission');
    console.error('Error fetching process permission:', error);
    throw error;
  }
}

export async function updateProcessPermission(code: string, data: CreateProcessAccessPermission) {
  try {
    const { data: resp } = await axios.put(
      `${APIUrls.Process.ProcessAccessPermission}/${code}`,
      data
    );
    toast.success('Process permission updated successfully');
    if (resp.data) {
      return resp.data;
    }
    return resp;
  } catch (error: any) {
    toast.error('Failed to update process permission');
    console.error('Error updating process permission:', error);
    throw error;
  }
}

export async function deleteProcessPermission(code: string) {
  try {
    const { data: resp } = await axios.delete(
      `${APIUrls.Process.ProcessAccessPermission}/${code}`
    );
    toast.success('Process permission deleted successfully');
    if (resp.data) {
      return resp.data;
    }
    return resp;
  } catch (error: any) {
    toast.error('Failed to delete process permission');
    console.error('Error deleting process permission:', error);
    throw error;
  }
}



export async function getProcessAccessPermissionUsers() {
  const {data: resp} = await axios.get(`${APIUrls.Process.ProcessAccessPermissionUsers}`);
  if (resp.data){
    return resp.data;
  }
  return resp;
}


export async function getProcessAccessGroupNames() {
  const {data: resp} = await axios.get(`${APIUrls.Process.ProcessGroupName}`);
  if (resp.data){
    const data= resp.data?.map((item:any) => ({ label: item.processDesignName, value: item.processDesignCode }));
    return data;
  }
    const data1= resp?.map((item:any) => ({ label: item.processDesignName, value: item.processDesignCode }));

  return data1;
}



export async function getDataTypes() {
  const {data: resp} = await axios.get(`${APIUrls.Record.RecProfiles}/data-types`);
  if (resp?.dataTypes){
    return resp?.dataTypes
  }
  return resp
}

export async function getProfileDetails(id : any) {
  const {data: resp} = await axios.get(`${APIUrls.Record.RecProfiles}/${id}`);
  if (resp.data){
    return resp.data
  }
  return resp
}

export async function postField(newUser:any,id:any) {
  try{
  const {data: resp} = await axios.put(`${APIUrls.Record.RecProfiles}/${id}`, newUser);
  toast.success('RecordProfile Updated successfully');
  return resp
  }catch (error: any) {
    toast.error(`RecordProfile not Updated successfully`);
  }
}

export async function postIcon(newUser:any) {
  try{
  const {data: resp} = await axios.put(`${APIUrls.Record.RecProfiles}/${newUser?.id}/icon`, newUser);
 toast.success('Icon Added successfully');
  return resp
  }catch (error: any) {
    toast.error(`Icon not Added successfully`);
  }
}
export async function addNewRec(newUser:any) {
  try{
  const {data: resp} = await axios.post(`${APIUrls.Record.RecProfiles}`, newUser);
  toast.success('RecordProfile Added successfully');
  return resp
  }catch (error: any) {
    toast.error(`RecordProfile not Added successfully`);
  }
}


export async function deleteRecPrf(code:any) {
  try {
    const {data: resp} = await axios.delete(`${APIUrls.Record.RecProfiles}/${code}`);
   toast.success('RecordProfile deleted successfully');
    return resp
  } catch (error: any) {
     toast.error(`RecordProfile not deleted successfully`);
  }
}

export async function addNewTask(processDesignCode: string, newTask: any) {
  try {
    const { data: resp } = await axios.post(
      `${APIUrls.ProcessTask?.ProcessTask}/${processDesignCode}/tasks`,
      newTask
    );
    toast.success('Task added successfully');
    return resp;
  } catch (error: any) {
    toast.error('Failed to add task');
    console.error('Error adding task:', error);
    throw error;
  }
}


export async function pickUpTask(code: string,subProcessCode: string) {
  try {
    const { data: resp } = await axios.post(
      `${APIUrls.ProcessTask?.ProcessTask}/${code}/${subProcessCode}/assign`,
      
    );
    // toast.success('Task picked up successfully');
    return resp;
  } catch (error: any) {
    toast.error('Failed to pick up task');
    console.error('Error picking up task:', error);
    throw error;
  }
}

export async function getProcessTasks(processDesignCode: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.ProcessTask.taskslist}/${processDesignCode}/tasks`
    );

    toast.success('Tasks fetched successfully');
    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch process tasks');
    console.error('Error fetching process tasks:', error);
    throw error;
  }
}

export async function getMyTasks(status?: string, priority?: string) {
  try {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (priority) params.append('priority', priority);
    
    const queryString = params.toString();
    const url = `${APIUrls.ProcessTask.taskslist}${queryString ? `?${queryString}` : ''}`;
    
    const { data: resp } = await axios.get(url);

    toast.success('Tasks fetched successfully');
    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch my tasks')
    console.error('Error fetching my tasks:', error)
    throw error
  }
}

export async function getSubProcessAssignees(processDesignCode: string,subProcessCode: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.ProcessTask.taskslist}/${processDesignCode}/${subProcessCode}/users`
    );

    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch assignees');
    console.error('Error fetching assignees:', error);
    throw error;
  }
}

export async function getTaskDetails(code: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.ProcessTask.taskslist}/${code}`
    );

    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch task Details');
    console.error('Error fetching task details:', error);
    throw error;
  }
}

export async function getProcessDesign(code: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.Process.ProcessDesign}/${code}`
    );

    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch Process Design');
    console.error('Error fetching process design:', error);
    throw error;
  }
}
export async function updateTransaction(code:string,subProcessCode:string,payload:any) {
  try{
  const {data: resp} = await axios.put(`${APIUrls.ProcessTask.taskslist}/${code}/${subProcessCode}/transaction`, payload);
  toast.success('Transaction Updated successfully');
  return resp
  }catch (error: any) {
    toast.error(`transaction Failed`);
  }
}

export async function updateTask(code:string,payload:any) {
  try{
  const {data: resp} = await axios.put(`${APIUrls.ProcessTask.ProcessTask}/${code}`, payload);
  toast.success('Task Updated successfully');
  return resp
  }catch (error: any) {
    toast.error(`Task updation Failed`);
  }
}

export async function getTaskRemarks(code: string) {
  try {
    const { data: resp } = await axios.get(
      `${APIUrls.ProcessTask.ProcessTask}/${code}/remarks`
    );

    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch remarks');
    console.error('Error fetching remarks:', error);
    throw error;
  }
}

export async function addNewRemark(code: string, newRemark: any) {
  try {
    const { data: resp } = await axios.post(
      `${APIUrls.ProcessTask?.ProcessTask}/${code}/remarks`,
      newRemark
    );
    toast.success('Remark added successfully');
    return resp;
  } catch (error: any) {
    toast.error('Failed to add remark');
    console.error('Error adding remark:', error);
    throw error;
  }
}


export async function getAllTasksSummary(lapseDays: number[]) {
  try {
    const queryParams = lapseDays.map(day => `lapseDays=${day}`).join('&');
    const { data: resp } = await axios.get(`${APIUrls.ProcessTask?.ProcessTask}/summary?${queryParams}`);
    return resp;
  } catch (error: any) {
    toast.error('Failed to fetch task summary');
    console.error('Error fetching task summary:', error);
    throw error;
  }
}